exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quick-link[data-v-2c353de7]{background:#d4e7f8;font-weight:bolder;text-transform:uppercase;cursor:pointer}", ""]);

// exports
